<template>
  <a-layout class="login animated fadeIn">
    <div class="model">
      <h3> <img src="@/assets/images/sigin_logo.png" alt=""></h3>
      <div class="login-form">
            <!-- <div class="ant-popover ant-popover-placement-leftTop" style="right:75px;left:initial;top:15px;">
          <div class="ant-popover-content">
            <div class="ant-popover-arrow">
            </div>
            <div class="ant-popover-inner" role="tooltip" style="background-color:#05486A">
              <div>
                <div class="ant-popover-inner-content">
                  <p style="color:#fff;">{{active==1?'账号登录在这里':'扫码登录在这里'}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s_position">
          <img class="width-26 height-21"  @click="active=2" src="@/assets/images/mmdl.png" v-if="active==1" alt="">
          <img class="width-25 height-25" @click="active=1" src="@/assets/images/smdl.png" v-if="active==2" alt="">
           
        </div> -->
        <!--  -->
        <div class="login_content">
          <div class="login_left">
            <div class="s_flex_center s_flex_fdc hei100 col_103f">
              <img src="@/assets/images/group.png" alt="" style="width:60px" class="mb10">
              <div class="s_font_b">人</div>
            </div>
            <div class="s_flex_center s_flex_fdc hei100 col_103f">
              <img src="@/assets/images/productData.png" alt="" style="width:60px" class="mb10">
              <div class="s_font_b">货</div>
            </div>
            <div class="s_flex_center s_flex_fdc hei100 col_103f">
              <img src="@/assets/images/viewData.png" alt="" style="width:60px" class="mb10">
              <div class="s_font_b">场</div>
            </div>
          </div>
          <div class="login_right">
            <div v-if="active==1">
              <div class="login_code">
                <img :src="codeState.image" width="250" height="250" alt="">
              </div>
              <div class="s_flex_center mt15 fz-18 s_c999">
                <ExpandOutlined class="mr10" />扫码登录  
              </div>
            </div>
            <!--  -->
            <div v-if="active==2">
              <div class="login-nav">
                密码登录
              </div>

              <div class="login_form">
                <!-- 密码登录 -->
                <a-form :model="formModel" @finish="handleSubmitFinish" v-if="activeForm==1">
                  <a-form-item name="account" :rules="[{ required: true, message: '请输入用户名' }]">
                    <a-input v-model:value="formModel.account" placeholder="用户名">
                      <template #prefix>
                        <img src="@/assets/images/yonghuguanli-3@2x.png" width="20" height="20" alt="">
                      </template>
                    </a-input>
                  </a-form-item>
                  <a-form-item name="password" :rules="[{ required: true, message: '请输入密码' }]">
                    <a-input-password v-model:value="formModel.password" placeholder="密码">
                      <template #prefix>
                        <img src="@/assets/images/mima-5@2x.png" width="20" height="20" alt="">
                      </template>
                    </a-input-password>
                  </a-form-item>
                  <div class="rember">
                    <a-checkbox :checked="isRember" @change="onCheck">
                      记住密码
                    </a-checkbox>
                    <div @click="$router.push({path:'/forgetpasswordone'})" class="s_shou">忘记密码?</div>
                  </div>
                  <a-button type="primary" htmlType="submit" block :loading="loading">
                    登录
                  </a-button>
                </a-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copy"><a href="https://hebeigaoda.com" style="font-size:12px; color:#666; margin-top:15px;">
            &copy; 2025 高大永恒塑料制品有限公司. 保留所有权利.<br>
            ICP备案号：冀ICP备2026022338号-1
        </a></div>
    </div>
  </a-layout>
</template>


<script>
import * as icon from "@ant-design/icons-vue";
import { sendLogin, getCode } from "@/api/login";
import { iscode } from "@/utils/app";
import { inject, onMounted, reactive, toRefs } from "vue";
import { message } from 'ant-design-vue';
export default {
  components: { ...icon },
  name: "Login",
  setup() {
    const state = reactive({
      visible: true,
      loading: false,
      formModel: {
        account: "",
        password: "",
        login_type: 4,
      },
      isRember: false, //是否记住密码
      active: 2,
      activeForm: 1,
      codeState: {},
    });
    const $router = inject("$router");
    // 获取扫码登陆二维码
    const getQrcode = async () => {
      let result = await getCode()
        .then((res) => res.data)
        .catch((error) => error);
      state.codeState = result.data;
    };
    const $store = inject("$store");
    const handleSubmitFinish = async () => {
      state.loading = true;
      let res = await sendLogin({
        account: state.formModel.account,
        password: state.formModel.password,
        login_type: 4,
      })
        .then((res) => res.data)
        .catch((error) => error);
      state.loading = false;
      if (iscode(res)) {
        if (state.isRember) {
          localStorage.setItem("loginForm", JSON.stringify(state.formModel));
        }
        localStorage.setItem("token", res.data.token);
        $router.push("/");
        $store.commit("user/SET_USER_TOKEN", res.data.token);
        $store.dispatch("user/setUserInfo", res.data);
      }else{
        message.error(res.msg)
      }
      state.loading = false;
    };
    // 记住密码
    const onCheck = (e) => {
      state.isRember = e.target.checked;
    };

    onMounted(() => {
      if (localStorage.getItem("loginForm")) {
        state.formModel = JSON.parse(localStorage.getItem("loginForm"));
        state.isRember = true;
      }
      // getQrcode();
    });

    return {
      ...toRefs(state),
      handleSubmitFinish,
      onCheck
    };
  },
};
</script>
<style lang="less" >
@import "@/style/views/login.less";
</style>


